<template>
    <section class="catalog-item mt-0 mt-md-4 product-page-item">
        <div class="row">
            <div class="col-12 col-lg-7 mb-3 mb-lg-0">
                <ProductImagesCarousel :product="product" />
            </div>
            <div class="col-12 col-lg-5 d-flex flex-column">
                <div class="row">
                    <div class="col">
                        <h1 class="product-name pt-3 pt-lg-0 mb-0 pb-2">{{ product.name }}</h1>
                    </div>
                </div>
                <div class="flex-wrap mb-3 align-items-start">
                    <ProductBadges :product="product" extra-class="font-size-14"/>
                </div>
                <div class="product-page-details mt-auto d-flex flex-wrap">
                    <div class="flex-grow-1">
                        <ProductPriceTable
                            :product="product"
                            :use-small-tag="true"
                            :show-premium="false"
                            :show-no-stock="false"
                            :show-shipping-price="false"
                        />
                    </div>
                </div>
                <template v-if="!product.is_archived">
                    <ProductQuantityHandler :product="product" v-if="product.shop_availability"/>
                    <div v-if="!product.shop_availability" class="row pt-3">
                        <div class="col">
                            <NotifyButton :product_id="product.id" />
                        </div>
                    </div>
                </template>

                <template v-if="product.metal_id">
                    <div class="mt-4">
                        <TierPricing v-if="product.shop_availability"
                            :product="product"
                            :show-vat="false"
                            :product-page="true"
                        />
                    </div>
                </template>
            </div>
        </div>
    </section>

    <section class="product-detail-container mt-4">
        <div class="row">
            <div class="col-12 col-xl-7 d-flex flex-column" :class="{'col-xl-12': store.relatedProducts.length === 0 && store.recommendations.length === 0}">
                <ProductAccordion :product="product" accordion-id="desktop" />
                <BuyBackBlock v-if="product.metal_id && store.showBuyBack" />
            </div>
            <div class="col-12 col-xl-5 d-flex flex-column">
                <WhyBuyBlock/>
                <ThumbsSection
                    title="products.customers_also_bought"
                    :products="store.relatedProducts"
                />
                <ThumbsSection
                    title="Recommendations"
                    :products="store.recommendations"
                />
            </div>
        </div>
    </section>

    <ProductSuggestions :small="true" :product-ids="[product.id]" />
</template>

<script setup>
import { useProductPageStore } from '~/stores/ProductPageStore'
import { useProductQuantityStore } from '~/stores/ProductQuantityStore'

import ProductImagesCarousel from '~/components/Product/ProductImagesCarousel.vue'
import ProductQuantityHandler from '~/components/Product/ProductQuantityHandler.vue'
import NotifyButton from '~/components/Product/Buttons/NotifyButton.vue'
import ProductPriceTable from '~/components/Product/ProductPriceTable.vue'
import ThumbsSection from '~/components/Product/Page/ThumbsSection.vue'
import BuyBackBlock from '~/components/Product/Page/BuyBackBlock.vue'
import ProductAccordion from '~/components/Product/Page/ProductAccordion.vue'
import TierPricing from '~/components/Product/Page/TierPricing.vue'
import ProductBadges from "~/components/Product/Page/ProductBadges.vue";
import ProductSuggestions from "~/components/Product/Page/ProductSuggestions.vue";
import WhyBuyBlock from "~/components/Product/Page/WhyBuyBlock.vue";

const store = useProductPageStore()
const router = useRouter()

store.setProduct(router.currentRoute.value.path)
const product = store.product

useProductQuantityStore().setQuantity(product.id, useCartStore().getProductQuantity(product.id));

useProductTierPricing(product);
</script>

<style scoped>
@media (min-width: 992px) {
    .row {
        --bs-gutter-x: 50px;
    }
}
</style>
